import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "tailwindcss/tailwind.css";
import useFetchData from "repo/get.js";
import FichaDetails from "components/hooks/FichaDetails";


function CardOcorrencia() {
  const [data, setData] = useState([]);
  const [selectedFicha, setSelectedFicha] = useState(null);
  const [filters, setFilters] = useState({
    'codigodeficha': { value: null, matchMode: 'contains' },
    'final': { value: null, matchMode: 'contains' },
    'local': { value: null, matchMode: 'contains' },
    'motorista': { value: null, matchMode: 'contains' },
  });
  const baseSelect = localStorage.getItem("baseSelected") || "";
  const cargoSelect = localStorage.getItem("cargo") || "";
  const { data: apiData } = useFetchData(`api/romaneios/getMinimalAll/ocorrencia/${baseSelect}`);

  useEffect(() => {
    if (apiData) {
      const formattedData = apiData.map((ficha) => ({
        ...ficha,
        codigodeficha: ficha.codigoUid,
        local: ficha.entregador,
        motorista: ficha.motorista,
        final: ficha.cidade,
      }));

      if (cargoSelect === "ENTREGADOR") {
        setData(formattedData.filter(func => func.entregador === localStorage.getItem("nome")));
      }
      else {
        setData(formattedData);
      }

    }
  }, [apiData]);

  const onRowSelect = (e) => {
    setSelectedFicha(e.data);
  };

  const closeDetails = () => {
    setSelectedFicha(null);
  };

  const header = (
    <div className="table-header">
      <div className="flex flex-col md:flex-row  justify-between items-center w-full">
        <span className="p-input-icon-left">
          <InputText
            type="search"
            onInput={(e) => setFilters({ ...filters, global: { value: e.target.value, matchMode: 'contains' } })}
            placeholder="Buscar..."
          />
        </span>
        <h4 className="p-input-icon-right text-2xl uppercase font-bold text-blueGray-700 ml-auto">
          {data.length} Sacas Ocorrência
        </h4>
      </div>
    </div>
  );

  return (
    <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white p-6">
      
      {selectedFicha && (
        <Dialog header="Detalhes da Ficha" visible={true} style={{ width: '70%' }} onHide={closeDetails}>
          <FichaDetails ficha={selectedFicha.codigoUid} onClose={closeDetails} />
        </Dialog>
      )}

      <DataTable
        value={data}
        paginator
        rows={25}
        stripedRows
        rowsPerPageOptions={[5, 10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
        selectionMode="single"
        onRowSelect={onRowSelect}
        filters={filters}
        globalFilterFields={['codigodeficha', 'final', 'local', 'motorista']}
        emptyMessage="Nenhum resultado encontrado."
        header={header}
      >
        <Column field="codigodeficha" header="Código de Ficha" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
        <Column field="final" header="Local" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
        <Column field="local" header="Entregador" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
        <Column field="motorista" header="Motorista" sortable style={{ minWidth: '12rem', fontSize: '13px' }} />
      </DataTable>
    </div>
  );
}

export default CardOcorrencia;
